export default __webpack_public_path__ + "static/media/Kindness.ece9af85.png";